<template>
  <div class="d-flex justify-space-evenly" v-if="notMenu">
    <div class="ma-2">
      <v-text-field
        v-model="datePart"
        :label="$t('common.dateLabel')"
        readonly
      />
      <v-date-picker
        no-title
        width="240px"
        header-color="accent"
        v-model="datePart"
      />
    </div>
    <div class="ma-2">
      <v-menu
        left
        v-model="timeMenu"
        :close-on-content-click="false"
        nudge-bottom="50"
        transition="scale-transition"
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="timeInput"
            @blur="tryUpdate"
            :rules="timeRules"
            :label="$t('common.timeLabel')"
          >
            <template v-slot:prepend>
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="mr-2"
                style="cursor: pointer"
              >
                mdi-clock-time-four-outline
              </v-icon>
            </template>
          </v-text-field>
        </template>
        <v-time-picker
          width="290"
          header-color="accent"
          v-model="timePart"
          format="24hr"
          scrollable
        />
      </v-menu>
    </div>
  </div>

  <div class="d-flex justify-space-between align-center" v-else>
    <v-menu
      ref="menu"
      v-model="dateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="datePart"
          :label="$t('common.dateLabel')"
          prepend-icon="mdi-clock-time-four-outline"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>

      <v-date-picker header-color="accent" v-model="datePart"></v-date-picker>
    </v-menu>

    <v-menu
      ref="menu"
      v-model="timeMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="timePart"
          :label="$t('common.timeLabel')"
          prepend-icon="mdi-clock-time-four-outline"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker
        width="290"
        header-color="accent"
        v-model="timePart"
        format="24hr"
        scrollable
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
const timeRegex = /^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/;

export default {
  name: "SoDateTimePicker",

  props: {
    value: {
      type: Date,
      default: new Date(),
    },

    format: {
      default: "yyyy-MM-dd HH:mm:ss",
    },

    continouslyDeconstruct: {
      type: Boolean,
      default: false,
    },

    notMenu: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      datePart: undefined,
      timePart: undefined,

      timeMenu: false,
      dateMenu: false,

      timeInput: undefined,
      timeRules: [
        (v) => !!v || this.$t("validation.dateFormat", ["HH:mm"]),
        (v) => timeRegex.test(v) || this.$t("validation.dateFormat", ["HH:mm"]),
      ],
    };
  },

  methods: {
    tryUpdate() {
      if (timeRegex.test(this.timeInput)) this.timePart = this.timeInput;
    },
  },

  created() {
    // 1. Deconstruct datetime if provided
    var dateTime = this.humanDate(this.value, "yyyy-MM-dd HH:mm");
    var parts = dateTime.split(" ");
    if (parts.length > 1) {
      this.datePart = parts[0];
      this.timePart = parts[1];
      this.timeInput = parts[1];
    }
  },

  watch: {
    value: {
      handler(val) {
        if (this.continouslyDeconstruct && val) {
          var dateTimeParts = this.humanDate(val, "yyyy-MM-dd HH:mm").split(
            " "
          );
          if (dateTimeParts.length > 1) {
            this.datePart = dateTimeParts[0];
            this.timePart = dateTimeParts[1];
            this.timeInput = dateTimeParts[1];
          }
        }
      },
    },

    timePart() {
      // Set the time part of the date
      this.timeInput = this.timePart;
      this.$emit("input", new Date(`${this.datePart} ${this.timePart}`));
    },

    datePart() {
      // Set the time part of the date
      this.$emit("input", new Date(`${this.datePart} ${this.timePart}`));
    },
  },
};
</script>
